// Vocations e atributos por level, com as fórmulas do Tibia Global.
// Até o level 8 todos ganham como "sem vocation"; a partir do 8, cada vocation tem seus ganhos.

export type VocationId = 'knight' | 'paladin' | 'sorcerer' | 'druid' | 'monk';

export interface Vocation {
  id: VocationId;
  name: string;
  promoted: string;
  /** título da segunda promotion (quest do level 400) */
  second: string;
  hpPerLevel: number;
  manaPerLevel: number;
  capPerLevel: number;
}

export const VOCATIONS: readonly Vocation[] = [
  { id: 'knight', name: 'Knight', promoted: 'Elite Knight', second: 'Vanguard Knight', hpPerLevel: 15, manaPerLevel: 5, capPerLevel: 25 },
  { id: 'paladin', name: 'Paladin', promoted: 'Royal Paladin', second: 'Sovereign Paladin', hpPerLevel: 10, manaPerLevel: 15, capPerLevel: 20 },
  { id: 'sorcerer', name: 'Sorcerer', promoted: 'Master Sorcerer', second: 'Archmage Sorcerer', hpPerLevel: 5, manaPerLevel: 30, capPerLevel: 10 },
  { id: 'druid', name: 'Druid', promoted: 'Elder Druid', second: 'Archdruid', hpPerLevel: 5, manaPerLevel: 30, capPerLevel: 10 },
  { id: 'monk', name: 'Monk', promoted: 'Exalted Monk', second: 'Ascended Monk', hpPerLevel: 10, manaPerLevel: 10, capPerLevel: 25 },
];

export const VOCATION_IDS = VOCATIONS.map((v) => v.id);

/** Level com que o personagem nasce. Sem Rookgaard, a vocation é escolhida na criação. */
export const START_LEVEL = 8;

export function getVocation(id: string): Vocation | undefined {
  return VOCATIONS.find((v) => v.id === id);
}

/** Promotion (Torre dos Heróis): level, preço e o que ela dá. A segunda vem só da quest do level 400. */
export const PROMOTION = { level: 20, price: 20_000 } as const;
export const SECOND_PROMOTION = { level: 400, statPct: 5, skillBonus: 1 } as const;

/** Nome mostrado da vocation: 0 = sem promotion, 1 = promovido, 2 = segunda promotion. */
export function vocationTitle(id: VocationId, promotion = 0): string {
  const v = getVocation(id);
  if (!v) return id;
  return promotion >= 2 ? v.second : promotion >= 1 ? v.promoted : v.name;
}

export interface BaseStats {
  maxHealth: number;
  maxMana: number;
  capacity: number;
}

export function statsForLevel(vocation: VocationId, level: number): BaseStats {
  if (!Number.isInteger(level) || level < 1) throw new Error(`level inválido: ${level}`);
  const v = getVocation(vocation);
  if (!v) throw new Error(`vocation inválida: ${vocation}`);
  const early = Math.min(level, 8);
  let maxHealth = 5 * (early + 29);
  let maxMana = 5 * (early + 10);
  let capacity = 10 * (early + 39);
  if (level > 8) {
    const extra = level - 8;
    maxHealth += extra * v.hpPerLevel;
    maxMana += extra * v.manaPerLevel;
    capacity += extra * v.capPerLevel;
  }
  return { maxHealth, maxMana, capacity };
}

/** Velocidade base mostrada no cliente (sem montaria nem haste). */
export function speedForLevel(level: number): number {
  return 109 + level;
}
